import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberAdditionalDocumentForm from '../../../components/forms/MemberAdditionalDocumentForm';
import { useMemberAdditionalDocumentApi } from '../../../hooks/useMemberAdditionalDocumentApi';
import { useNavigate } from 'react-router-dom';
import { MemberAdditionalDocumentDTO } from '../../../services/apiClient';

const MemberAdditionalDocumentCreate: React.FC = () => {
  const { create, isLoading } = useMemberAdditionalDocumentApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Additional Documents', href: '/admin/documents' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberAdditionalDocumentDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/documents#additional');
    } catch (error) {
      console.error('Error creating MemberAdditionalDocument:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/documents"
      breadcrumbs={breadcrumbs}
      allowedRoles={['User']}
      requiredPermission='Manage.MemberAdditionalDocument.Edit'
    >
        <MemberAdditionalDocumentForm
          initialValues={{} as MemberAdditionalDocumentDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/documents#additional')}
          isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default MemberAdditionalDocumentCreate;